import PlanCategories from "../../mixins/PlanCategories";

const quoteDataReset = function (quoteModule) {
  let category = quoteModule.quote_data.current_category;

  // Check if user data protection is enabled
  const dataProtection = quoteModule.generator_bar?.data_protection;
  if (dataProtection?.protect_user_data) {
    return quoteModule;
  }

  // Check if navigation is in progress and protect recent user input
  if (dataProtection?.navigation_in_progress) {
    return quoteModule;
  }

  // Check if data protection was recently active (within last 5 seconds)
  if (dataProtection?.last_protection_time) {
    const timeSinceProtection =
      Date.now() - dataProtection.last_protection_time;
    if (timeSinceProtection < 5000) {
      // 5 seconds
      return quoteModule;
    }
  }

  switch (category) {
    case PlanCategories.IMMIGRANT.TYPE:
      let qDataImmigrant = quoteModule.quote_data.immigrant;
      let immigrantDest = quoteModule.quote_data_states.destination.immigrant;
      let immigrantTrav = quoteModule.quote_data_states.traveler.immigrant;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataImmigrant.destination_state = immigrantDest.isValid
            ? qDataImmigrant.destination_state
            : null;
          break;
        case "traveler":
          qDataImmigrant.travelers = qDataImmigrant.travelers.filter(
            (trav, index) => {
              return immigrantTrav.data[index]?.isValid;
            }
          );
          break;
      }

      break;
    case PlanCategories.J1.TYPE:
      let qDataJ1 = quoteModule.quote_data.j1;
      let j1Dest = quoteModule.quote_data_states.destination.j1;
      let j1Trav = quoteModule.quote_data_states.traveler.j1;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataJ1.destination_state = j1Dest.isValid
            ? qDataJ1.destination_state
            : null;
          break;
        case "traveler":
          qDataJ1.travelers = qDataJ1.travelers.filter((trav, index) => {
            return j1Trav.data[index]?.isValid;
          });
          break;
      }
      break;
    case PlanCategories.SCHENGEN.TYPE:
      let qDataSchengen = quoteModule.quote_data.schengen;
      let schengenDest = quoteModule.quote_data_states.destination.schengen;
      let schengenTrav = quoteModule.quote_data_states.traveler.schengen;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataSchengen.destinations = qDataSchengen.destinations.filter(
            (dest, index) => {
              return schengenDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataSchengen.travelers = qDataSchengen.travelers.filter(
            (trav, index) => {
              return schengenTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
    case PlanCategories.STUDENT.TYPE:
      let qDataStudent = quoteModule.quote_data.student;
      let studentDest = quoteModule.quote_data_states.destination.student;
      let studentTrav = quoteModule.quote_data_states.traveler.student;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataStudent.destination_state = studentDest.isValid
            ? qDataStudent.destination_state
            : null;
          break;
        case "traveler":
          qDataStudent.travelers = qDataStudent.travelers.filter(
            (trav, index) => {
              return studentTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
    case PlanCategories.TRIP.TYPE:
    case PlanCategories.CFAR.TYPE:
      let qDataTrip = quoteModule.quote_data.trip;
      let tripDest = quoteModule.quote_data_states.destination.trip;
      let tripTrav = quoteModule.quote_data_states.traveler.trip;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataTrip.destinations = qDataTrip.destinations.filter(
            (dest, index) => {
              return tripDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          // Protect user-entered traveler data from being cleared
          // Only remove travelers that are truly invalid (not just validation state issues)
          qDataTrip.travelers = qDataTrip.travelers.filter((trav, index) => {
            const travState = tripTrav.data[index];

            // Preserve travelers with any user-entered data regardless of validation state
            const hasUserData =
              (trav.age !== null &&
                trav.age !== undefined &&
                trav.age !== "") ||
              (trav.dob !== null &&
                trav.dob !== undefined &&
                trav.dob !== "") ||
              (trav.trip_cost !== null && trav.trip_cost !== undefined) ||
              (trav.residence_country !== null &&
                trav.residence_country !== undefined) ||
              (trav.residence_state !== null &&
                trav.residence_state !== undefined);

            // If traveler has user data, preserve it regardless of validation state
            if (hasUserData) {
              return true;
            }

            // Only filter out completely empty travelers that are also marked invalid
            return travState?.isValid;
          });
      }
      break;
    case PlanCategories.VISITOR.TYPE:
      let qDataVisitor = quoteModule.quote_data.visitor;
      let visitorDest = quoteModule.quote_data_states.destination.visitor;
      let visitorTrav = quoteModule.quote_data_states.traveler.visitor;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataVisitor.destinations = qDataVisitor.destinations.filter(
            (dest, index) => {
              return visitorDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataVisitor.travelers = qDataVisitor.travelers.filter(
            (trav, index) => {
              return visitorTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
    case PlanCategories.PREEX.TYPE:
      let qDataPreex = quoteModule.quote_data.preex;
      let preexDest = quoteModule.quote_data_states.destination.preex;
      let preexTrav = quoteModule.quote_data_states.traveler.preex;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataPreex.destinations = qDataPreex.destinations.filter(
            (dest, index) => {
              return preexDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataPreex.travelers = qDataPreex.travelers.filter((trav, index) => {
            return preexTrav.data[index]?.isValid;
          });
          break;
      }
      break;
    case PlanCategories.ADDND.TYPE:
      let qDataAddnd = quoteModule.quote_data.addnd;
      let addndDest = quoteModule.quote_data_states.destination.addnd;
      let addndTrav = quoteModule.quote_data_states.traveler.addnd;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataAddnd.destinations = qDataAddnd.destinations.filter(
            (dest, index) => {
              return addndDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataAddnd.travelers = qDataAddnd.travelers.filter((trav, index) => {
            return addndTrav.data[index]?.isValid;
          });
          break;
      }
      break;
    case PlanCategories.MEDEVAC.TYPE:
      let qDataMedevac = quoteModule.quote_data.medevac;
      let medevacDest = quoteModule.quote_data_states.destination.medevac;
      let medevacTrav = quoteModule.quote_data_states.traveler.medevac;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataMedevac.destinations = qDataMedevac.destinations.filter(
            (dest, index) => {
              return medevacDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataMedevac.travelers = qDataMedevac.travelers.filter(
            (trav, index) => {
              return medevacTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
    case PlanCategories.OPTSTUDENT.TYPE:
      let qDataOptstudent = quoteModule.quote_data.optstudent;
      let optstudentDest = quoteModule.quote_data_states.destination.optstudent;
      let optstudentTrav = quoteModule.quote_data_states.traveler.optstudent;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataOptstudent.destination_state = optstudentDest.isValid
            ? qDataOptstudent.destination_state
            : null;
          break;
        case "traveler":
          qDataOptstudent.travelers = qDataOptstudent.travelers.filter(
            (trav, index) => {
              return optstudentTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
    case PlanCategories.CRUISE.TYPE:
      let qDataCruise = quoteModule.quote_data.cruise;
      let cruiseDest = quoteModule.quote_data_states.destination.cruise;
      let cruiseTrav = quoteModule.quote_data_states.traveler.cruise;

      switch (quoteModule.generator_bar.data_reset_target) {
        case "country":
          qDataCruise.destinations = qDataCruise.destinations.filter(
            (dest, index) => {
              return cruiseDest.data[index]?.isValid;
            }
          );
          break;
        case "traveler":
          qDataCruise.travelers = qDataCruise.travelers.filter(
            (trav, index) => {
              return cruiseTrav.data[index]?.isValid;
            }
          );
          break;
      }
      break;
  }

  return quoteModule;
};
export default quoteDataReset;
